module.exports = __webpack_public_path__ + "static/media/210623_guidance_3.fcafe6c7.png";